import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'shared/events/bub_events';

import styles from 'stylesheets/components/collapsible_dropdown_menu';
import arrowDownIcon from 'images/arrow-down.png';
import classNames from 'classnames';

export function CollapsibleDropdownMenu(props) {
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState('0px');

  const content = useRef(null);

  function toggleAccordion() {
    setActive(!active);
    setHeight(active ? '0px' : `${content.current.scrollHeight}px`);
  }

  function trackCategoryClick(category) {
    return () => {
      bubEvents.track('Featured Category Buttons', 'Clicked card', {
        label: 'Category',
        value: category.displayName,
        id: category.id,
      });
    };
  }

  return (
    <div className={styles.collapsibleDropdownMenu}>
      <button className={styles.accordion} onClick={toggleAccordion}>
        <div></div>
        <p className={styles.accordionTitle}>{props.title}</p>
        <div className={styles.arrowContainer}>
          <img
            aria-label='arrow'
            src={arrowDownIcon}
            className={classNames(styles.arrowIcon, { [styles.rotate]: active })}
          />
        </div>
      </button>
      <div ref={content} className={styles.accordionContent} style={{ maxHeight: `${height}` }}>
        {props.items.map(tag => (
          <a hidden={!active} className={styles.menuRow} href={tag.url} key={tag.id} onClick={trackCategoryClick(tag)}>
            {tag.displayName}
          </a>
        ))}
      </div>
    </div>
  );
}

CollapsibleDropdownMenu.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
